import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET } from "../../services/axios.service";
import { RootState } from "../../app/store";
import { SessionProps } from "../../types/session";

export interface SessionsState {
  sessions: SessionProps[];
  loading: boolean;
  error: string | null;
}

const initialState: SessionsState = {
  sessions: [],
  loading: false,
  error: null,
};

export const fetchSessionsData = createAsyncThunk(
  "fetchSessionsData",
  async () => {
    let response: any;
    await GET(`/v1/sessions`, {})
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const sessionsSlice = createSlice({
  name: "sessions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchSessionsData.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(fetchSessionsData.fulfilled, (state, action: any) => {
      state.loading = false;
      if (action.payload?.data?.status === "success") {
        state.sessions = action.payload.data.data.sessions || [];
        state.error = null;
      } else {
        state.sessions = [];
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    });
    builder.addCase(fetchSessionsData.rejected, (state, action: any) => {
      state.sessions = [];
      state.loading = false;
      state.error =
        action?.payload?.data?.message ||
        "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
    });
  },
});

export const getSessions = (state: RootState) => state.sessions.sessions;
export const getSessionsLoading = (state: RootState) => state.sessions.loading;

export default sessionsSlice.reducer;
